import ModelIcon from '@/assets/svg/model-icon.svg?raw'
import FrameIcon from '@/assets/svg/frame-icon.svg?raw'
import TempleIcon from '@/assets/svg/temple-icon.svg?raw'
import LensIcon from '@/assets/svg/len-icon.svg?raw'
import LensOptionIcon from '@/assets/svg/len-option-icon.svg?raw'
import LogoIcon from '@/assets/svg/logo-icon.svg?raw'
import BridgeIcon from '@/assets/svg/bridge-icon.svg?raw'
import ModelFrameIcon from '@/assets/img/model_frame_icon.jpg'
import ModelRimlessIcon from '@/assets/img/model_rimless_icon.jpg'
import FrameColorIcon from '@/assets/svg/frame_color_icon.svg?url'
import FramePatternIcon from '@/assets/svg/frame_pattern_icon.svg?url'
import LensClearIcon from '@/assets/img/lens_clear_icon.png'
import LensOrdinaryIcon from '@/assets/img/lens_ordinary_icon.png'
import LensFunctionIcon from '@/assets/img/lens_function_icon.png'
import LensFunctionIcon1 from '@/assets/img/lens_function_icon_5.jpg'
import LensFunctionIcon2 from '@/assets/img/lens_function_icon_2.jpg'
import LensFunctionIcon3 from '@/assets/img/lens_function_icon_3.jpg'
import LensFunctionIcon4 from '@/assets/img/lens_function_icon_4.jpg'
import LensFunctionIcon5 from '@/assets/img/lens_function_icon_1.jpg'
import LensFunctionIcon6 from '@/assets/img/lens_function_icon_6.jpg'
import LensOptionIcon1 from '@/assets/svg/lens_option_1.svg?url'
import LensOptionIcon2 from '@/assets/svg/lens_option_4.svg?url'
import LensOptionIcon3 from '@/assets/svg/lens_option_2.svg?url'
import LensOptionIcon4 from '@/assets/svg/lens_option_3.svg?url'
// import LensOptionIcon5 from '@/assets/svg/lens_option_5.svg?url'
import LensOptionIcon6 from '@/assets/svg/lens_option_6.svg?url'
import Bridge_bg1 from '@/assets/img/bridge_1.jpg'
import Bridge_bg2 from '@/assets/img/bridge_2.jpg'

import { actionTypes, frameTypes, lenOptions, lenTypes, logoTypes, modelTypes } from '@/hooks/enums'

export const pricing = {
  model: {
    frame: 44000,
    rimless: 33000,
  },
  lensOption: {
    none: 0,
    lutina: 2200,
    mirror: 2200,
    strongest: 2200,
    bdc: 3300,
    esc: 1100,
  },
}

export const navConfigurations = {
  [modelTypes.FRAME]: [
    {
      type: actionTypes.MODEL,
      icon: ModelIcon,
      label: 'モデル',
      order: 1,
    },
    {
      type: actionTypes.FRAME,
      icon: FrameIcon,
      label: 'フレーム',
      order: 2,
    },
    {
      type: actionTypes.TEMPLE,
      icon: TempleIcon,
      label: 'チタン',
      order: 3,
    },
    {
      type: actionTypes.LENS,
      icon: LensIcon,
      label: 'レンズ',
      order: 4,
    },
    {
      type: actionTypes.LOGO,
      icon: LogoIcon,
      label: 'ロゴ',
      order: 5,
    },
    {
      type: actionTypes.LENOPTIONS,
      icon: LensOptionIcon,
      label: 'オプション',
      order: 6,
    },
    {
      type: actionTypes.BRIDGE,
      icon: BridgeIcon,
      disabled: true,
      label: 'ブリッジ',
      order: 7,
    },
  ],
  [modelTypes.RIMLESS]: [
    {
      type: actionTypes.MODEL,
      icon: ModelIcon,
      label: 'モデル',
      order: 1,
    },
    {
      type: actionTypes.TEMPLE,
      icon: TempleIcon,
      label: 'チタン',
      order: 2,
    },
    {
      type: actionTypes.BRIDGE,
      icon: BridgeIcon,
      label: 'ブリッジ',
      order: 3,
    },
    {
      type: actionTypes.LENS,
      icon: LensIcon,
      label: 'レンズ',
      order: 4,
    },
    {
      type: actionTypes.LENOPTIONS,
      icon: LensOptionIcon,
      label: 'オプション',
      order: 5,
    },
    {
      type: actionTypes.FRAME,
      icon: FrameIcon,
      disabled: true,
      label: 'フレーム',
      order: 6,
    },
    {
      type: actionTypes.LOGO,
      icon: LogoIcon,
      disabled: true,
      label: 'ロゴ',
      order: 7,
    },
  ],
}

export const model = {
  modelOptions: {
    [modelTypes.FRAME]: {
      label: 'フレイム',
      url: ModelFrameIcon,
      description: 'クリアカラー',
      price: pricing.model.frame,
    },
    [modelTypes.RIMLESS]: {
      label: 'リムレス',
      url: ModelRimlessIcon,
      description: 'パターン',
      price: pricing.model.rimless,
    },
  },
  // * Define sort order for the model
  onSales: {
    frame_camille_n: 10,
    frame_camille_w: 20,
    frame_claude: 30,
    frame_jeanne: 40,
    frame_louise: 50,
    frame_michael_n: 60,
    frame_michael_w: 70,
    frame_nicole: 80,
    frame_raphael: 90,
    frame_samuel: 100,
    frame_sylvie: 110,
    frame_valerie: 120,
    frame_celine: 130,
    frame_pascal: 150,
    rimless_square: 130,
    rimless_round: 140,
    rimless_oval: 150,
    rimless_hexagon_vertical: 160,
    rimless_hexagon: 170,
    rimless_drooping_eyes: 180,
    rimless_long_oval: 190,
  },
  onDev: {
    frame_alexia: 9,
    frame_albert: 10,
    frame_catherine: 20,
    frame_dimitri: 50,
    frame_gerard: 60,
    frame_marc: 70,
    frame_marion: 80,
    frame_victor: 90,
  },
  forChild: {
    frame_annie: 10,
    frame_yves: 20,
  },
}

export const frame = {
  frameOptions: {
    [frameTypes.COLOR]: {
      label: 'カラーフレーム',
      url: FrameColorIcon,
    },
    [frameTypes.PATTERN]: {
      label: 'パターン',
      url: FramePatternIcon,
    },
  },
}

export const len = {
  lenTypes: {
    [lenTypes.CLEAR]: {
      label: 'クリアレンズ',
      gtmKey: 'lens_color_clear_button',
      url: LensClearIcon,
      className: 'text-black',
    },
    [lenTypes.ORDINARY]: {
      label: '色で選ぶ',
      gtmKey: null,
      url: LensOrdinaryIcon,
      className: 'text-black',
    },
    [lenTypes.FUNCTION]: {
      label: '機能で選ぶ',
      gtmKey: null,
      url: LensFunctionIcon,
      className: 'text-white',
    },
  },
  lenOptions: {
    [lenOptions.NONE]: {
      label: 'オプションなし',
      url: LensOptionIcon1,
      description: '',
      excludes: [],
      additionFee: pricing.lensOption.none,
      width: '80px',
    },
    [lenOptions.LUTINA]: {
      label: 'ルティーナレンズ',
      url: LensOptionIcon2,
      description: 'ブルーライトを含む有害光線をブロック',
      excludes: [
        'function_fine_color_normal_gray_20',
        'function_fine_color_normal_brown_20',
        'function_fine_color_normal_purple_20',
        'function_fine_color_normal_pink_20',
        'function_fine_color_gradient_gray_15',
        'function_fine_color_gradient_gray_20',
        'function_fine_color_gradient_brown_15',
        'function_fine_color_gradient_brown_20',
        'function_fine_color_gradient_purple_15',
        'function_fine_color_gradient_purple_20',
        'function_fine_color_gradient_pink_15',
        'function_fine_color_gradient_pink_20',
        'function_active_view_night_drive',
        'function_pola_jade_blue',
        'function_pola_river_blue',
        'function_pola_meteor_gray',
        'function_pola_dark_orchid',
        'function_pola_iron_blue',
        'function_pola_gunmetal_gray',
        'function_pola_sand_brown',
        'function_pola_creek',
        'function_pola_dark_copper',
        'function_pola_moss_green',
        'function_pola_fire_brick',
        'function_pola_topazolite',
        'function_transitions_gray',
        'function_transitions_brown',
        'function_transitions_xtractive',
        'function_luthina_photo_gray',
        'function_luthina_photo_brown',
        'function_luthina_photo_surf_blue',
        'function_neutral_color_coat_ncc_black',
        'function_neutral_color_coat_ncc_light',
      ],
      additionFee: pricing.lensOption.lutina,
      width: '120px',
    },
    [lenOptions.MIRROR]: {
      label: 'ミラーコート加工',
      url: LensOptionIcon3,
      description: '淡い反射でファッション性UP',
      excludes: [
        'function_active_view_night_drive',
        'function_transitions_gray',
        'function_transitions_brown',
        'function_transitions_xtractive',
        'function_luthina_photo_gray',
        'function_luthina_photo_brown',
        'function_luthina_photo_surf_blue',
        'function_neutral_color_coat_ncc_black',
        'function_neutral_color_coat_ncc_light',
      ],
      additionFee: pricing.lensOption.mirror,
      width: '80px',
    },
    [lenOptions.STRONGEST]: {
      label: 'ウルトラシールドコート',
      url: LensOptionIcon4,
      description: '最強の耐摩耗性と傷耐性',
      excludes: [
        'function_active_view_night_drive',
        'function_pola_jade_blue',
        'function_pola_river_blue',
        'function_pola_meteor_gray',
        'function_pola_dark_orchid',
        'function_pola_iron_blue',
        'function_pola_gunmetal_gray',
        'function_pola_sand_brown',
        'function_pola_creek',
        'function_pola_dark_copper',
        'function_pola_moss_green',
        'function_pola_fire_brick',
        'function_pola_topazolite',
        'function_transitions_gray',
        'function_transitions_brown',
        'function_transitions_xtractive',
        'function_luthina_photo_gray',
        'function_luthina_photo_brown',
        'function_luthina_photo_surf_blue',
        'function_neutral_color_coat_ncc_black',
        'function_neutral_color_coat_ncc_light',
      ],
      additionFee: pricing.lensOption.strongest,
      width: '80px',
    },
    // [lenOptions.BDC]: {
    //   label: 'BDC',
    //   url: LensOptionIcon5,
    //   description: 'ブルーライト＆近赤外線カット',
    //   excludes: [
    //     'function_active_view_night_drive',
    //     'function_pola_jade_blue',
    //     'function_pola_river_blue',
    //     'function_pola_meteor_gray',
    //     'function_pola_dark_orchid',
    //     'function_pola_iron_blue',
    //     'function_pola_gunmetal_gray',
    //     'function_pola_sand_brown',
    //     'function_pola_creek',
    //     'function_pola_dark_copper',
    //     'function_pola_moss_green',
    //     'function_pola_fire_brick',
    //     'function_pola_topazolite',
    //     'function_transitions_gray',
    //     'function_transitions_brown',
    //     'function_transitions_xtractive',
    //     'function_luthina_photo_gray',
    //     'function_luthina_photo_brown',
    //     'function_luthina_photo_surf_blue',
    //     'function_neutral_color_coat_ncc_black',
    //     'function_neutral_color_coat_ncc_light',
    //   ],
    //   additionFee: pricing.lensOption.bdc,
    //   width: '140px',
    // },
    [lenOptions.ESC]: {
      label: 'ESC ＋ P-UV',
      url: LensOptionIcon6,
      description: '近赤外線＆反射UVカット',
      excludes: [
        'function_active_view_night_drive',
        'function_pola_jade_blue',
        'function_pola_river_blue',
        'function_pola_meteor_gray',
        'function_pola_dark_orchid',
        'function_pola_iron_blue',
        'function_pola_gunmetal_gray',
        'function_pola_sand_brown',
        'function_pola_creek',
        'function_pola_dark_copper',
        'function_pola_moss_green',
        'function_pola_fire_brick',
        'function_pola_topazolite',
        'function_transitions_gray',
        'function_transitions_brown',
        'function_transitions_xtractive',
        'function_luthina_photo_gray',
        'function_luthina_photo_brown',
        'function_luthina_photo_surf_blue',
        'function_neutral_color_coat_ncc_black',
        'function_neutral_color_coat_ncc_light',
      ],
      additionFee: pricing.lensOption.esc,
      width: '140px',
    },
  },
  lenFunctionIntro: {
    ファインカラー: {
      photo: LensFunctionIcon1,
      filtered: [modelTypes.FRAME, modelTypes.RIMLESS],
      subTitle: '日常のまぶしさ軽減',
    },
    アクティビュー: {
      photo: LensFunctionIcon5,
      filtered: [modelTypes.FRAME, modelTypes.RIMLESS],
      subTitle: 'まぶしさ↓、コントラスト↑',
    },
    ポラ: {
      photo: LensFunctionIcon2,
      filtered: [modelTypes.FRAME],
      subTitle: '乱反射、ギラつきカット',
      extraTitle: '(偏光レンズ)',
    },
    トランジションズ: {
      photo: LensFunctionIcon3,
      filtered: [modelTypes.FRAME, modelTypes.RIMLESS],
      subTitle: '紫外線でレンズの色の濃さが変化',
      extraTitle: '(調光レンズ)',
    },
    ルティーナフォト: {
      photo: LensFunctionIcon6,
      filtered: [modelTypes.FRAME, modelTypes.RIMLESS],
      subTitle: 'ルティーナ素材の調光レンズ',
    },
    ニュートラルカラーコート: {
      photo: LensFunctionIcon4,
      filtered: [modelTypes.FRAME, modelTypes.RIMLESS],
      subTitle: '色彩は変わらず、光量だけ抑える',
    },
  },
}

export const logo = {
  logoOptions: {
    [logoTypes.FRONT]: {
      label: '表面',
      value: '',
    },
    [logoTypes.BACK]: {
      label: '裏面',
      value: '',
    },
  },
}

export const bridge = {
  bridgeOptions: [
    {
      key: 'bridge_1',
      value: 'bridge_1',
      photo: Bridge_bg1,
    },
    {
      key: 'bridge_2',
      value: 'bridge_2',
      photo: Bridge_bg2,
    },
  ],
}

export const randomConfig = Object.freeze({
  timer: {
    model: 1000 * 30,
    part: 1000 * 5,
    autoRotate: 1000 * 5,
  },
  target: {
    models: [
      'frame_camille_n',
      'frame_camille_w',
      'frame_claude',
      'frame_jeanne',
      'frame_louise',
      'frame_michael_n',
      'frame_michael_w',
      'frame_nicole',
      'frame_raphael',
      'frame_samuel',
      'frame_sylvie',
      'frame_valerie',
      'frame_celine',
      'frame_pascal',
      'rimless_square',
      'rimless_round',
      'rimless_hexagon',
    ],
    frameColors: [
      'clear',
      'monotone_1',
      'monotone_6',
      'brown_4',
      'brown_5',
      'red_orange_2',
      'purple_6',
      'green_6',
      'blue_1',
      'red_pink_4',
      'red_pink_5',
      'yellow_5',
    ],
    templeColors: [
      'titanium_silver',
      'light_bronze',
      'bronze',
      'metallic_blue',
      'marine_blue',
      'blue_yellow',
      'yellow_gold',
      'gold',
      'antique_gold',
      'purple',
      'blue_purple',
      'lime_green',
    ],
    lenColors: [
      'clear',
      'normal_fair_ocher_35f',
      'normal_glow_orange_25f',
      'gradient_breeze_green_35g',
      'gradient_fair_brown_50g',
      'gradient_true_gray_35g',
      'gradient_breeze_navy_50g_20g',
      'gradient_glow_bordeaux_35g',
      'gradient_breeze_blue_35g',
      'gradient_copper_50g',
      'function_pola_dark_copper',
      'function_pola_iron_blue',
    ],
  },
})
